import $ from 'jquery';
$(document).ready(function () {

    (function () {
        let v = {
            _jsCookiesAcceptAll:                  '[data-cookies-accept-all]',
            _jsCookiesAcceptSelected:             '[data-cookies-accept-selected]',
            _jsCookiesDenied:                     '[data-cookies-denied]',
            _jsCookiesClose:                      '[data-cookies-close]',
            _jsCookiesShowAll:                    '[data-cookies-show-all]',
            _jsPopupChooseCookiesFirstBlock:      '[data-popup-choose-cookies-main]',
            _jsPopupChooseCookiesContent:         '[data-popup-choose-cookies-content]',
            _jsPopupChooseCookiesTab:             '[data-popup-choose-cookies-tab]',
            _jsPopupChooseCookiesTabsContentItem: '[data-popup-choose-cookies-tabcontent-item]',
            _jsPopupChooseCookiesDetails:         '[data-popup-choose-cookies-details]',
            _jsPopupChooseCookiesDetailsBlock:    '[data-popup-choose-cookies-details-block]',
            _jsPopupChooseCookiesMainInfo:        '[data-popup-choose-cookies-tabcontent-info]',
            _jsPopupCookies:                      '[data-popup-cookies]',
            _jsFooterPopupCookies:                '[data-footer-popup-cookies]',
        }

        $(document).on('click', v._jsCookiesAcceptAll, clickJsCookiesAcceptAll);
        $(document).on('click', v._jsCookiesAcceptSelected, clickJsCookiesAcceptAllSelected);
        $(document).on('click', v._jsCookiesDenied, clickJsCookiesDenied);
        $(document).on('click', v._jsCookiesClose, clickJsCookiesClose);
        $(document).on('click', v._jsCookiesShowAll, clickJsCookiesShowAll);
        $(document).on('click', v._jsPopupChooseCookiesTab, clickJsPopupChooseCookiesTab);
        $(document).on('click', v._jsPopupChooseCookiesDetails, clickJsPopupChooseCookiesDetails);
        $(document).on('click', v._jsFooterPopupCookies, showCookiesPopupAndSetAttribute);

        function sendSelectedBeforeLoadingPage()
        {
            let adStorage = 'denied',
                analyticsStorage = 'denied';
            if (typeof (Storage) !== "undefined") {
                adStorage = window.localStorage.getItem('adStorage') ? 'granted' : 'denied';
                analyticsStorage = window.localStorage.getItem('analyticsStorage') ? 'granted' : 'denied';
            } else {
                adStorage = $.cookie('adStorage') ? 'granted' : 'denied';
                analyticsStorage = $.cookie('analyticsStorage') ? 'granted' : 'denied';
            }

            dataLayer.push({
                'ad_storage_def': adStorage,
                'analytics_storage_def': analyticsStorage,
                'event': 'consent_mode_def'
            });
        }

        function showPopupCookies()
        {
            ///cookies popup block
            if (typeof (Storage) !== "undefined") {
                if (!window.localStorage.getItem('cookiePopup')) {
                    showCookiesPopupAndSetAttribute();
                }
            } else {
                if (!$.cookie('cookiePopup')) {
                    showCookiesPopupAndSetAttribute();
                }
            }
        }

        function showCookiesPopupAndSetAttribute()
        {
            $(v._jsPopupCookies).show();
            $(v._jsPopupCookies).attr('data-cookies-popup-visible', '');
        }

        function clickJsCookiesAcceptAll()
        {
            let adStorage = 'granted',
                analyticsStorage = 'granted';

            if (typeof (Storage) !== "undefined") {
                window.localStorage.setItem('cookiePopup', 'true');
            } else {
                $.cookie('cookiePopup', 'true');
            }

            window.localStorage.setItem('adStorage', 'true');
            $.cookie('adStorage', 'true');
            window.localStorage.setItem('analyticsStorage', 'true');
            $.cookie('analyticsStorage', 'true');

            $(v._jsPopupCookies).hide();

            dataLayer.push({
                'ad_storage': adStorage,
                'analytics_storage': analyticsStorage,
                'event': 'consent_mode_option'
            });
        }

        function clickJsCookiesAcceptAllSelected()
        {
            let adStorage = 'granted',
                analyticsStorage = 'granted';

            if (!$('input[name=adStorageDef]').is(':checked')) {
                adStorage = 'denied';
            }

            if (!$('input[name=analyticsStorageDef]').is(':checked')) {
                analyticsStorage = 'denied';
            }

            if (typeof (Storage) !== "undefined") {
                window.localStorage.setItem('cookiePopup', 'true');
            } else {
                $.cookie('cookiePopup', 'true');
            }

            if (adStorage === 'granted') {
                window.localStorage.setItem('adStorage', 'true');
                $.cookie('adStorage', 'true');
            } else {
                window.localStorage.removeItem('adStorage');
                $.removeCookie('adStorage');
            }

            if (analyticsStorage === 'granted') {
                window.localStorage.setItem('analyticsStorage', 'true');
                $.cookie('analyticsStorage', 'true');
            } else {
                window.localStorage.removeItem('analyticsStorage');
                $.removeCookie('analyticsStorage');
            }

            $(v._jsPopupCookies).hide();

            dataLayer.push({
                'ad_storage': adStorage,
                'analytics_storage': analyticsStorage,
                'event': 'consent_mode_option'
            });
        }

        function clickJsCookiesDenied()
        {
            if (typeof (Storage) !== "undefined") {
                window.localStorage.setItem('cookiePopup', 'true');
            }

            window.localStorage.removeItem('adStorage');
            window.localStorage.removeItem('analyticsStorage');
            $.removeCookie('adStorage');
            $.removeCookie('analyticsStorage');

            $(v._jsPopupCookies).hide();

            dataLayer.push({
                'ad_storage_def': 'denied',
                'analytics_storage_def': 'denied',
                'event': 'consent_mode_option'
            });
        }

        function clickJsCookiesClose()
        {
            $(v._jsPopupCookies).hide();
        }

        function clickJsCookiesShowAll()
        {
            $(this).closest(v._jsPopupChooseCookiesFirstBlock).hide();
            $(v._jsPopupChooseCookiesContent).show();
        }

        function clickJsPopupChooseCookiesTab()
        {
            if (!$(this).hasClass("active")) {
                $(v._jsPopupChooseCookiesTab).removeClass("active").eq($(this).index()).addClass("active");
                $(v._jsPopupChooseCookiesTabsContentItem).hide().eq($(this).index()).fadeIn()
            }
        }

        function clickJsPopupChooseCookiesDetails(e)
        {
            e.preventDefault();

            $(this).closest(v._jsPopupChooseCookiesTabsContentItem)
                .find(v._jsPopupChooseCookiesMainInfo)
                .toggle();


            $(this).closest(v._jsPopupChooseCookiesTabsContentItem)
                .find(v._jsPopupChooseCookiesDetailsBlock)
                .toggle();
        }

        sendSelectedBeforeLoadingPage();
        showPopupCookies();
    })();
});


